module.exports = __webpack_public_path__ + "static/media/yikatong_zqgq.198ae3c9.jpeg";